/**
 * Represents a Scheduler Anchor component.
 * @class
 */
export default class SchedulerAnchor {
  /**
   * Creates a new instance of SchedulerAnchor.
   * @constructor
   * @param {string} url - The URL to schedule a tour.
   */
  constructor() {
    this.anchorId = 'schedulerAnchor';
  }

  /**
   * Sets the URL for the scheduler anchor.
   * @param {string} url - The URL to set.
   */
  setUrl(url) {
    this.url = url;
  }

  /**
   * Binds events to the SchedulerAnchor component.
   * @function bindEvents
   * @memberof SchedulerAnchor
   * @instance
   */
  bindEvents() {
    const anchor = this.getAnchor();
    anchor?.addEventListener('click', ()=> document.body.dispatchEvent(new CustomEvent('schedulerAnchorClick')));
  }

  /**
   * Gets the anchor element by ID.
   * @returns {HTMLElement} The anchor element.
   */
  getAnchor() {
    return document.getElementById(this.anchorId);
  }

  /**
   * Gets the HTML for the scheduler anchor.
   * @returns {string} The HTML for the scheduler anchor.
   */
  getHtml() {
    return this.url
      ? `
      <a data-close data-qa="ScheduleaTour" id="${this.anchorId}" href="${this.url}" target="_blank" class="btn btn--yellow btn--48-lg">
              Don’t Miss Out!<br> Schedule a Tour Now
      </a>`
      : ``;
}
}
  